module.exports = __webpack_public_path__ + "static/media/Coffee.d28a9c54.jpg";